module.exports = __webpack_public_path__ + "static/img/wisdom_park1.cc1a1ae8.png";